<template>
  <div id="page-project">
    <!--<h3>project page {{msg}}</h3> размер каталога: {{this.$store.state.tableData.length}} записей <br>-->
    <keep-alive><workspace/></keep-alive>
  </div>
</template>




<script>
import toolbar from '@/components/toolbar'
import workspace from '@/components/workspace'
import vue from 'vue'
import {mapState} from 'vuex'

  export default {
    name: 'project',
    components: {
      workspace
    },

  data () {
    return {
      msg: 'Welcome to project view'
    }
  },

  created: function () {   
    console.log('project created: ' + this.msg);
  },

  mounted () {
     // this.$store.dispatch('loadCatalog','/data/jrecords.json');
      //this.$store.loadCatalog('asfdadfsdf');
  },

  computed: {
      ...mapState(['tableData', 'editorData'])
  }

 }

</script>